/* Paper HeartZ — shop behaviours: hero slideshow, size guide modal, size/variant picker */
(function () {
  'use strict';

  /* ---------- crossfade slideshows (shop hero, exclusives tile) ---------- */
  function burger() {
    var btn = document.querySelector('[data-phz-burger]');
    var header = document.querySelector('[data-phz-header]');
    if (!btn || !header) return;

    function set(open) {
      header.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function isOpen() { return header.classList.contains('is-open'); }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      set(!isOpen());
    });
    // tapping a link, pressing Escape, or tapping outside all close it
    header.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.phz-menu a')) set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { set(false); btn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !header.contains(e.target)) set(false);
    });
    // returning to the desktop breakpoint must not leave it stuck open
    window.addEventListener('resize', function () {
      if (isOpen() && window.innerWidth > 820) set(false);
    });
  }

  function slideshow(root) {
    var slides = root.querySelectorAll('[data-phz-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-phz-dot]');
    var delay = parseInt(root.getAttribute('data-phz-interval'), 10) || 5000;
    var i = 0, timer = null;

    function ready(n) {
      var im = slides[(n + slides.length) % slides.length];
      return im.complete && im.naturalWidth > 0;
    }
    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) slides[s].style.opacity = s === i ? '1' : '0';
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
    }
    // hold on the current slide until the next one has actually decoded; fading to a
    // still-loading lazy image showed a black hero on slow/mobile connections
    function advance() {
      for (var step = 1; step <= slides.length; step++) {
        if (ready(i + step)) { show(i + step); return; }
      }
    }
    function start() { stop(); timer = setInterval(advance, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation(); show(n); start();
        });
      })(d);
    }
    show(0);
    start();
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }

  /* ---------- size guide modal ---------- */
  function sizeGuide() {
    var modal = document.querySelector('[data-phz-chart]');
    if (!modal) return;
    var openers = document.querySelectorAll('[data-phz-chart-open]');

    function open() { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }

    for (var o = 0; o < openers.length; o++) {
      openers[o].addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.hasAttribute('data-phz-chart-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- click-to-zoom on the product image ---------- */
  var WIDE_RATIO = 2.5; /* wide-and-short images (size charts) upscale to the viewport width */

  function imageZoom() {
    var stage = document.querySelector('.phz-pdp__stage');
    var img = stage && stage.querySelector('img');
    if (!img) return;

    var box = document.createElement('div');
    box.className = 'phz-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', 'Zoomed product image');
    box.innerHTML = '<button type="button" class="phz-zoom__x phz-mono" aria-label="Close">\u2715</button><img alt="">';
    document.body.appendChild(box);

    var big = box.querySelector('img');

    big.addEventListener('load', function () {
      var wide = big.naturalHeight && (big.naturalWidth / big.naturalHeight) > WIDE_RATIO;
      big.classList.toggle('is-wide', wide);
    });

    function open() {
      big.src = img.currentSrc || img.src;
      big.alt = img.alt || '';
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      box.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    stage.addEventListener('click', open);
    box.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- product: size buttons + gallery thumbs ---------- */
  function productForm() {
    var form = document.querySelector('[data-phz-product]');
    if (!form) return;

    var idInput = form.querySelector('[data-phz-variant-id]');
    var buttons = form.querySelectorAll('[data-phz-size]');
    var addBtn = form.querySelector('[data-phz-add]');

    function select(btn) {
      for (var b = 0; b < buttons.length; b++) buttons[b].classList.remove('is-on');
      btn.classList.add('is-on');
      if (idInput) idInput.value = btn.getAttribute('data-phz-variant');
      if (addBtn) {
        var sold = btn.getAttribute('data-phz-available') === 'false';
        addBtn.disabled = sold;
        addBtn.textContent = sold ? 'SOLD OUT' : 'ADD TO CART';
      }
    }

    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.getAttribute('data-phz-available') === 'false') return;
        btn.addEventListener('click', function (e) { e.preventDefault(); select(btn); });
      })(buttons[i]);
    }

    var first = form.querySelector('[data-phz-size][data-phz-available="true"]');
    if (first) select(first);

    /* gallery — thumbs and arrows both drive one index */
    var main = document.querySelector('[data-phz-main-image]');
    var thumbs = document.querySelectorAll('[data-phz-thumb]');
    if (!main || !thumbs.length) return;

    var at = 0;
    function show(i) {
      at = (i + thumbs.length) % thumbs.length;   /* wraps both directions */
      main.src = thumbs[at].getAttribute('data-phz-full');
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('is-on');
      thumbs[at].classList.add('is-on');
    }

    for (var t = 0; t < thumbs.length; t++) {
      (function (i) {
        thumbs[i].addEventListener('click', function (e) { e.preventDefault(); show(i); });
      })(t);
    }

    function step(d) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();   /* the stage's own click opens the zoom — don't trigger it */
        show(at + d);
      };
    }
    var prev = document.querySelector('[data-phz-prev]');
    var next = document.querySelector('[data-phz-next]');
    if (prev) prev.addEventListener('click', step(-1));
    if (next) next.addEventListener('click', step(1));

    document.addEventListener('keydown', function (e) {
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
      if (e.key === 'ArrowLeft') show(at - 1);
      else if (e.key === 'ArrowRight') show(at + 1);
    });

    show(0);
  }

  function headerSearch() {
    var box = document.querySelector('[data-phz-hsearch]');
    if (!box) return;
    var input = box.querySelector('input[type=search]');

    box.addEventListener('toggle', function () {
      if (box.open && input) input.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.open) {
        box.open = false;
        box.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (box.open && !box.contains(e.target)) box.open = false;
    });
  }

  function init() {
    var shows = document.querySelectorAll('[data-phz-slideshow]');
    for (var i = 0; i < shows.length; i++) slideshow(shows[i]);
    burger();
    headerSearch();
    sizeGuide();
    productForm();
    imageZoom();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
